module.exports = __webpack_public_path__ + "img/login-stock.f4f8ca1c.png";